import React from 'react'
import PropTypes from 'prop-types'
import style from './Button.less'
import classNames from 'classnames'


const Button = (props) => {
  const getClasses = () => {
    const classes = [style.main]
    if (props.icon) {
      classes.push(style.icon)
    }
    if (props.display == 'flex') {
      classes.push(style.flex)
    }
    if (props.fullWidth) {
      classes.push(style.fullWidth)
    }
    if (props.fullWidthPrimary) {
      classes.push(style.fullWidthPrimary)
    }
    if (props.secondary) {
      classes.push(style.secondary)
    }
    if (props.disable) {
      classes.push(style.disable)
    }
    if (props.modal) {
      classes.push(style.modal)
    }
    if (props.uppercase) {
      classes.push(style.uppercase)
    }
    if (props.invalid) {
      classes.push(style.invalid)
    }
    return classes
  }

  return (
    <button
      className={classNames(...getClasses())}
      onClick={props.onClick}
      data-test="button"
    >
      <span className={style.wrapper}>
        {props.icon &&
          <svg viewBox={props.icon.viewBox}>
            <use xlinkHref={`#${props.icon.id}`} />
          </svg>
        }
        <span>{props.label}</span>
      </span>
    </button>
  )
}


Button.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  icon: PropTypes.object,
  display: PropTypes.string,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  secondary: PropTypes.bool,
  modal: PropTypes.bool,
  disable: PropTypes.bool,
  fullWidthPrimary: PropTypes.bool,
  uppercase: PropTypes.bool,
  invalid: PropTypes.bool,
}

export default Button
